<icc-list
    [searchable]="true"
    [items]="fittings"
    [itemTemplate]="'itemImgTitle'"
    (select)="selectFitting($event)"
    [selected]="selectedFittingId"
    (showInfo)="showInfo($event)"
    ></icc-list>
